import { render, staticRenderFns } from "./EditUbicazioneView.vue?vue&type=template&id=171f9b86&"
import script from "./EditUbicazioneView.vue?vue&type=script&lang=js&"
export * from "./EditUbicazioneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports